import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsersTable = _resolveComponent("UsersTable")

  return (_openBlock(), _createBlock(_component_UsersTable, {
    list: _ctx.list,
    "widget-classes": "mb-5 mb-xl-8"
  }, null, 8, ["list"]))
}